import {useSelector} from 'react-redux';
import {UseSendProps, ChannelType} from '../../../hooks/sendHooks.types';
import {prepareParameterValuesForSave} from '../../../component/whatsAppTemplateEditor/hooks/useTemplateStructure';
import setGlobalState from '../../../redux/setGlobalState';
import {TState} from '../../../redux/store.type';
import {saveFreeWhatsAppMessage} from '../../../redux/branding/brandingActions';
import {serializeTemplateStructure} from '../../whatsAppTemplateEditor/utils/formatUtils';
import {useEffect} from 'react';
import {getUserPreferences} from '../../../redux/user/userActions';

export const useSend = ({whatsappData, emailData, smsData, show, sendFunction, saveFunction, data, saveData}: UseSendProps) => {

    const source = saveData?.source as string | undefined;
    const currentSaved = useSelector((s: TState) =>
        source ? s.mailing?.designMailing?.[source] ?? null : null
    );
    const whatsappEditorMode = useSelector((s: TState) => {
        if(!source) return null;
        return s.ui.whatsappEditorMode?.[source];
    });
    const loaderSuppressed = useSelector((s: TState) => Boolean(s.user?.preferences?.hideWhatsappFreeLoader));
    const getUserPreferencesXHR = useSelector((s: TState) => s.user.getUserPreferencesXHR);
    useEffect(() => {
        if(!getUserPreferencesXHR) {
            getUserPreferences().then();
        }
    }, []);
    const handleSend = async (type: ChannelType, trialRecipients?: string[]) => {
        const prepared = whatsappData.whatsappTemplate ? prepareParameterValuesForSave(whatsappData.whatsappTemplate) : [];
        const messageData = {
            whatsapp: {...whatsappData, parameterValues: prepared},
            email: emailData,
            sms: smsData,
        };
        try {
            await sendFunction(type, {
                ...messageData[type],
                ...(trialRecipients && {trialRecipients}),
                ...data
            });
            return true;
        } catch (error) {
            console.error('Failed to send:', error);
            show.close();
            return false;
        }
    };

    const handleSave = async (type: ChannelType) => {
        if(!saveFunction) return false;
        if(type === 'email' && !emailData.emailBody) return false;
        if(type === 'sms' && !smsData.message) return false;

        const payload: Record<string, unknown> = {messageType: type, ...saveData};
        const updated = {...(currentSaved ?? {})};

        if(type === 'whatsapp') {
            const hasFreeChanged = whatsappData.message !== serializeTemplateStructure(whatsappData.whatsappTemplate);
            if(whatsappEditorMode === 'free' && hasFreeChanged) {
                if(getUserPreferencesXHR === 'SUCCESS' && !loaderSuppressed) {
                    setGlobalState('ui.show.isOpenAiLoaderPopup', true);
                }
                await saveFreeWhatsAppMessage(whatsappData.message, source, source);
                return true;
            } else if(whatsappData.whatsappTemplate) {
                const message = JSON.stringify(whatsappData.whatsappTemplate);
                payload.bodyMessage = message;
                updated.whatsappContent = message;
            }
        }
        if(type === 'email') {
            payload.bodyMessage = emailData.emailBody;
            payload.subject = emailData.emailSubject;
            updated.emailContent = emailData.emailBody;
            updated.emailSubject = emailData.emailSubject;
        } else if(type === 'sms') {
            payload.bodyMessage = smsData.message;
            updated.smsContent = smsData.message;
        }

        await saveFunction(payload);
        if(source) {
            setGlobalState(`mailing.designMailing.${source}`, updated);
        }
        return true;
    };

    return {handleSend, handleSave};
};
